export const SITUACOES = {
  LANCADO: 'LANÇADO',
  CANCELADO: 'CANCELADO',
  APROVADO: 'APROVADO',
  FINALIZADO: "FINALIZADO"
};
